import { render, staticRenderFns } from "./QrcodeLogin.vue?vue&type=template&id=ed0b1c60&scoped=true"
import script from "./QrcodeLogin.vue?vue&type=script&lang=js"
export * from "./QrcodeLogin.vue?vue&type=script&lang=js"
import style0 from "./QrcodeLogin.vue?vue&type=style&index=0&id=ed0b1c60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0b1c60",
  null
  
)

export default component.exports